export default __webpack_public_path__ + "static/media/obs_step7.870d40a8.png";